import React, { useRef, useState } from 'react';
import { OverlayPanel } from 'primereact/overlaypanel';
import { assignButtonCSS, assignPopoverCSS } from './Cotizaciones.css';

const AssignButton = ({
    title = 'Asignar Vendedor',
    currentAdvisorId,
    vendors = [],
    onAssign,
    loading = false,
    disabled = false,
}) => {
    const op = useRef(null);
    const [busyId, setBusyId] = useState(null);

    const handleSelect = async (vendorId) => {
        if (busyId !== null) return;
        try {
            setBusyId(vendorId ?? 'none');
            await onAssign(vendorId);
            op.current?.hide();
        } finally {
            setBusyId(null);
        }
    };

    const isAssigned = currentAdvisorId !== null && currentAdvisorId !== undefined;

    return (
        <>
            <button
                type="button"
                css={assignButtonCSS(isAssigned)}
                disabled={disabled || loading}
                onClick={(e) => op.current?.toggle(e)}
                title={isAssigned ? 'Reasignar vendedor' : 'Asignar vendedor'}
            >
                <i className={loading ? 'pi pi-spin pi-spinner' : (isAssigned ? 'pi pi-user-edit' : 'pi pi-user-plus')} />
                <span>{isAssigned ? 'Reasignar' : 'Asignar'}</span>
            </button>

            <OverlayPanel ref={op} dismissable showCloseIcon={false} appendTo={typeof document !== 'undefined' ? document.body : undefined}>
                <div css={assignPopoverCSS()}>
                    <div className="ap-title">{title}</div>

                    {vendors.length === 0 && (
                        <div className="ap-empty">No hay Vendedores Trim activos.</div>
                    )}

                    <ul className="ap-list">
                        {vendors.map((v) => {
                            const isCurrent = Number(v.id) === Number(currentAdvisorId);
                            const busy = busyId === v.id;
                            return (
                                <li key={v.id}>
                                    <button
                                        type="button"
                                        className={`ap-item${isCurrent ? ' is-current' : ''}`}
                                        onClick={() => handleSelect(v.id)}
                                        disabled={busy || isCurrent}
                                    >
                                        <span className="ap-item-name">{v.name}</span>
                                        {v.email && <span className="ap-item-email">{v.email}</span>}
                                        {isCurrent && <span className="ap-item-tag">Actual</span>}
                                        {busy && <i className="pi pi-spin pi-spinner ap-spinner" />}
                                    </button>
                                </li>
                            );
                        })}
                    </ul>

                    {isAssigned && (
                        <button
                            type="button"
                            className="ap-unassign"
                            onClick={() => handleSelect(null)}
                            disabled={busyId === 'none'}
                        >
                            {busyId === 'none' ? (
                                <i className="pi pi-spin pi-spinner" />
                            ) : (
                                <i className="pi pi-user-minus" />
                            )}
                            <span>Quitar asignación</span>
                        </button>
                    )}
                </div>
            </OverlayPanel>
        </>
    );
};

export default AssignButton;
